import { Component, input, output } from '@angular/core';
import { SurveyListOption } from '@hyper-inferno/survey-elements-core';

@Component({
  selector: 'lib-dynamic-list-preview',
  imports: [],
  templateUrl: './dynamic-list-preview.html',
  styleUrl: './dynamic-list-preview.css',
})
export class DynamicListPreview {
  displayNames = input<SurveyListOption[]>([]); 
  editListEvent = output<void>();
  editList(){
    this.editListEvent.emit();
  }
}
